import { AxiosResponse } from 'axios';
import AxiosInstance from './AxiosInstance';

export const me = async (): Promise<AxiosResponse> => AxiosInstance.get('me');
